import { render } from "./Subscribers.vue?vue&type=template&id=02dc5b41"
import script from "./Subscribers.vue?vue&type=script&setup=true&lang=js"
export * from "./Subscribers.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Subscribers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02dc5b41"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02dc5b41', __exports__)) {
    api.reload('02dc5b41', __exports__)
  }
  
  module.hot.accept("./Subscribers.vue?vue&type=template&id=02dc5b41", () => {
    api.rerender('02dc5b41', render)
  })

}


export default __exports__